import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { BrowseAppraisals, BulkAppraisalPayments } from '@roc/feature-appraisals';

const getAppraisalRoutesV2Config = (
  basePath: string,
  baseUrl: string
) => {
  return {
    browseAppraisalOrders: {
      path: `${basePath}/appraisal-orders`,
      url: `${baseUrl}/appraisal-orders`,
      documentTitle: 'Appraisal Orders',
    },
    appraisalPayments: {
      path: `${basePath}/appraisal-payments`,
      url: `${baseUrl}/appraisal-payments`,
      documentTitle: 'Appraisal Payments',
    },
  };
};

export const getAppraisalRoutesV2 = (
  basePath: string,
  baseUrl: string
) => {
  const config = getAppraisalRoutesV2Config(basePath, baseUrl);

  return {
    browseAppraisalOrders: (
      <Route exact path={config.browseAppraisalOrders.path}>
        <Page routeDefinition={config.browseAppraisalOrders}>
          <BrowseAppraisals />
        </Page>
      </Route>
    ),
    appraisalPayments: (
      <Route exact path={config.appraisalPayments.path}>
        <Page routeDefinition={config.appraisalPayments}>
          <BulkAppraisalPayments />
        </Page>
      </Route>
    ),
  };
}
